$(function(){
  $('.replyShow-box').hide(); // 初期状態を非表示に
  var i = 1
  while(i <= gon.comment_replies.length){
    const jsIndex = i;
    $('.doReply-btn' + jsIndex).on('click', function(){
      $('.commentReply' + jsIndex).slideDown(600);
      $('.replyShow-box' + jsIndex ).slideDown(600);
      $('.doReply-btn' + jsIndex).css('display','none');
      $('.showReply-btn' + jsIndex).css('display','none');
      $('.notShowReply-btn' + jsIndex).css('display','block');
    });

    $('.showReply-btn' + jsIndex).on('click', function(){
      $('.commentReply' + jsIndex).slideUp(600);
      $('.replyShow-box' + jsIndex).slideDown(600);
      $('.doReply-btn' + jsIndex).css('display','block');
      $('.showReply-btn' + jsIndex).css('display','none');
      $('.notShowReply-btn' + jsIndex).css('display','block');
    });


    $('.notShowReply-btn' + jsIndex).on('click', function(){
      $('.commentReply' + jsIndex).slideUp(600);
      $('.replyShow-box' + jsIndex).slideUp(600);
      $('.doReply-btn' + jsIndex).css('display','block');
      $('.showReply-btn' + jsIndex).css('display','block');
      $('.notShowReply-btn' + jsIndex).css('display','none');
    });
    i ++;
  };
});
